import { render, staticRenderFns } from "./TheAboutTab.vue?vue&type=template&id=39f4fdb7&"
import script from "./TheAboutTab.vue?vue&type=script&lang=js&"
export * from "./TheAboutTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports